<template>
  <!-- 全部招标：全量招投标项目，不按负责人过滤（sceneType 不传） -->
  <BidProjectList :show-creator-filter="true" :show-tabs="false" />
</template>

<script lang="ts" setup>
import BidProjectList from '../components/BidProjectList.vue'

defineOptions({ name: 'CrmBidAll' })
</script>
